var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNps05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFB600;stroke-width:3;stroke-miterlimit:10;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFB600;stroke:#FFB600;stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 63.1,
    className: "st0",
    width: 12.8,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    y: 63.1,
    className: "st1",
    width: 12.8,
    height: 7.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.1,
    y: 63.1,
    className: "st2",
    width: 12.8,
    height: 7.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.8,15.2C33.3,15.2,24,24.5,24,36s9.3,20.8,20.8,20.8S65.6,47.5,65.6,36S56.3,15.2,44.8,15.2z M50.8,24.3 c0.9-1,2.1-1,3,0c0.8,0.9,1,2,1,3c0,1.2-0.3,2.2-1,3c-0.9,1-2.1,1-3,0C49.5,28.8,49.5,25.8,50.8,24.3z M35.1,27.1 c0.1-0.9,0.2-1.6,0.7-2.4c0.8-1.4,2.3-1.4,3.3-0.1c1.1,1.4,1.1,4.1,0,5.5c-1,1.3-2.3,1.3-3.3,0C35.1,29.3,34.9,28.1,35.1,27.1z  M55.1,38.1c-1.6,2.3-3.7,4-6.4,4.8c-1.2,0.4-2.6,0.5-3.3,0.7c-4.8-0.2-8.2-1.9-10.7-5.4c-0.6-0.8-0.5-1.5,0.2-2 c0.6-0.4,1.3-0.2,1.9,0.5c1.4,1.9,3.2,3.2,5.5,3.9c4,1.1,8.2-0.3,10.7-3.7c0.2-0.3,0.5-0.7,0.8-0.8c0.5-0.1,1,0.1,1.4,0.3 C55.5,36.9,55.4,37.5,55.1,38.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNps05);
export default __webpack_public_path__ + "static/media/nps-05.3accbbc3ad0955531421fcc0ead66406.svg";
export { ForwardRef as ReactComponent };